/**
 * Created by zhangsanfeng on 2020/5/21.
 */

export const mock = {
  //甲板
  deck: [
    {name: '甲板1', num: '1号', id: 1},
    {name: '甲板2', num: '2号', id: 2},
  ],

  //区域
  area: [
    {id: 1, name: '特殊区域1', type: 'special', deck: '甲板1', points: []},
    {
      id: 2,
      name: '特殊区域2（有模拟数据）',
      type: 'special',
      deck: '甲板1',
      points: [
        {x: 1493, y: 471},
        {x: 2227, y: 561},
        {x: 2484, y: 1048},
        {x: 1816, y: 1188},
        {x: 1201, y: 885}
      ]
    },
    {id: 3, name: '特殊区域3', type: 'special', deck: '甲板1', points: []},
    {id: 4, name: '特殊区域4', type: 'special', deck: '甲板1', points: []},
    {id: 5, name: '特殊区域5', type: 'special', deck: '甲板1', points: []},
    {id: 6, name: '普通区域1', type: 'common', deck: '甲板1', points: []},
    {id: 7, name: '普通区域2', type: 'common', deck: '甲板2', points: []},
    {id: 8, name: '普通区域3', type: 'common', deck: '甲板1', points: []},
    {id: 9, name: '普通区域4', type: 'common', deck: '甲板1', points: []},
    {id: 10, name: '普通区域5', type: 'common', deck: '甲板1', points: []},
  ],

  //过道
  passage: [
    {
      id: 1,
      name: '过道1',
      direction: 'horizontal',
      left_up_through: false,
      left_up_point: {x: 0, y: 0},
      right_bottom_through: true,
      right_bottom_point: {x: 1868, y: 369},
      deck_id: 1,  //deck: '甲板1',
    },
    {
      id: 2,
      name: '过道2',
      direction: 'horizontal',
      left_up_through: true,
      left_up_point: {x: 1943, y: 553},
      right_bottom_through: false,
      right_bottom_point: {x: 0, y: 0},
      deck_id: 1,      //deck: '甲板1',
    },
    {
      id: 3,
      name: '过道3',
      direction: 'vertical',
      deck_id: 1,   //deck: '甲板1',
      left_up_through: true,
      left_up_point: {x: 1866, y: 525},
      right_bottom_through: false,
      right_bottom_point: {x: 0, y: 0}
    },
    {
      id: 4,
      name: '过道4',
      direction: 'horizontal',
      left_up_through: false,
      left_up_point: {x: 0, y: 0},
      right_bottom_through: true,
      right_bottom_point: {x: 3975, y: 592},
      deck_id: 2,  //deck: '甲板2',
    },
    {
      id: 5,
      name: '过道5',
      direction: 'horizontal',
      left_up_through: true,
      left_up_point: {x: 4037, y: 585},
      right_bottom_through: false,
      right_bottom_point: {x: 0, y: 0},
      deck_id: 2, //deck: '甲板2',
    },
  ],

  //同甲板连接过道
  deck_connect_passage: [
    {
      deck_id: 2,
      connect: [
        {
          deck_id: 2,
          passage1_name: '过道4',
          passage1_id: 4,
          passage1_point: 'right_bottom',
          passage2_name: '过道5',
          passage2_id: 5,
          passage2_point: 'left_up',
        },
      ]
    },
    {
      deck_id: 1,
      connect: [
        {
          deck_id: 1,
          passage1_name: '过道1',
          passage1_id: 1,
          passage1_point: 'right_bottom',
          passage2_name: '过道2',
          passage2_id: 2,
          passage2_point: 'left_up',
        },
        {
          deck_id: 1,
          passage1_name: '过道1',
          passage1_id: 1,
          passage1_point: 'right_bottom',
          passage2_name: '过道3',
          passage2_id: 3,
          passage2_point: 'left_up',
        },
        {
          deck_id: 1,
          passage1_name: '过道2',
          passage1_id: 2,
          passage1_point: 'left_up',
          passage2_name: '过道3',
          passage2_id: 3,
          passage2_point: 'left_up',
        },
      ]
    }
  ],

  //楼梯
  stair: [
    {
      id: 1,
      name: '楼梯1',
      deck1: {name: '甲板1', id: 1},
      passage1: {name: '过道1', id: 1},
      point1: {x: 1569, y: 457},
      deck2: {name: '甲板2', id: 2},
      passage2: {name: '过道4', id: 4},
      point2: {x: 3628, y: 535},
    },
    {
      id: 2,
      name: '楼梯2',
      deck1: {name: '甲板1', id: 1},
      passage1: {name: '过道2', id: 2},
      point1: {x: 2039, y: 527},
      deck2: {name: '甲板2', id: 2},
      passage2: {name: '过道5', id: 5},
      point2: {x: 4182, y: 561},
    }
  ],

  //基站
  station: [
    {
      id: 26,
      name: '基站26',
      deck_id: 1,
      passage_id: 1,
      points: [{x: 463, y: 370}]  //默认[{x:0,y:0}]
    },
    {
      id: 35,
      name: '基站35',
      deck_id: 1,
      passage_id: 1,
      points: [{x: 1594, y: 371},]
    },
    {
      id: 6,
      name: '基站6',
      deck_id: 1,
      passage_id: 1,
      points: [{x: 1687, y: 780}, {x: 1739, y: 512}, {x: 1747, y: 390}]
    },
    {
      id: 7,
      name: '基站7',
      deck_id: 1,
      passage_id: 3,
      points: [{x: 1652, y: 1088}, {x: 1789, y: 958}, {x: 1869, y: 938}]
    },
    {
      id: 34,
      name: '基站34',
      deck_id: 1,
      passage_id: 2,
      points: [{x: 1947, y: 484}, {x: 1952, y: 545}]
    },
    {
      id: 22,
      name: '基站22',
      deck_id: 1,
      passage_id: 2,
      points: [{x: 2454, y: 362}, {x: 2332, y: 509}, {x: 2342, y: 554}]
    },
    {
      id: 25,
      name: '基站25',
      deck_id: 1,
      passage_id: 2,
      points: [{x: 2677, y: 402}, {x: 2640, y: 520}, {x: 2639, y: 562}]
    },
    {
      id: 27,
      name: '基站27',
      deck_id: 2,
      passage_id: 4,
      points: [{x: 3174, y: 579}]
    },
    {
      id: 4,
      name: '基站4',
      deck_id: 2,
      passage_id: 4,
      points: [{x: 3971, y: 583}]
    },
    {
      id: 45,
      name: '基站45',
      deck_id: 2,
      passage_id: 4,
      points: [{x: 3866, y: 393}, {x: 3738, y: 457}, {x: 3734, y: 579}]
    },
    {
      id: 19,
      name: '基站19',
      deck_id: 2,
      passage_id: 5,
      points: [{x: 4199, y: 347}, {x: 4087, y: 462}, {x: 4068, y: 583}]
    },
    {
      id: 30,
      name: '基站30',
      deck_id: 2,
      passage_id: 5,
      points: [{x: 4468, y: 362}, {x: 4424, y: 592}]
    },
    {
      id: 28,
      name: '基站28',
      deck_id: 2,
      passage_id: 5,
      points: [{x: 4760, y: 592}]
    },

  ],

  //模拟路径
  temp_path: [
    {
      user: {id: 1, name: '张一丰'},
      paths: [
        {
          station_id: 26,
          station_name: '基站26',
          deck_id: 1,
          passage_id: 1,
          station_points: [{x: 463, y: 370}],
          millisecond: 1589617035000,
          type: 'in'
        },
        {
          station_id: 26,
          station_name: '基站26',
          deck_id: 1,
          passage_id: 1,
          station_points: [{x: 463, y: 370}],
          millisecond: 1589617036000,
          type: 'out'
        },
        {
          station_id: 35,
          station_name: '基站35',
          deck_id: 1,
          passage_id: 1,
          station_points: [{x: 1594, y: 371},],
          millisecond: 1589617038000,
          type: 'in'
        },
        {
          station_id: 35,
          station_name: '基站35',
          deck_id: 1,
          passage_id: 1,
          station_points: [{x: 1594, y: 371},],
          millisecond: 1589617040000,
          type: 'out'
        },
        {
          station_id: 6,
          station_name: '基站6',
          deck_id: 1,
          passage_id: 1,
          station_points: [{x: 1687, y: 780}, {x: 1739, y: 512}, {x: 1747, y: 390}],
          millisecond: 1589617041000,
          type: 'in'
        },
        {
          station_id: 6,
          station_name: '基站6',
          deck_id: 1,
          passage_id: 1,
          station_points: [{x: 1687, y: 780}, {x: 1739, y: 512}, {x: 1747, y: 390}],
          millisecond: 1589617042000,
          type: 'out'
        },
      ]
    },
    {
      user: {id: 2, name: '张二丰'},
      paths: [
        {
          station_id: 7,
          station_name: '基站7',
          deck_id: 1,
          passage_id: 3,
          station_points: [{x: 1652, y: 1088}, {x: 1789, y: 958}, {x: 1869, y: 938}],
          millisecond: 1589617044000,
          type: 'in'
        },
        {
          station_id: 7,
          station_name: '基站7',
          deck_id: 1,
          passage_id: 3,
          station_points: [{x: 1652, y: 1088}, {x: 1789, y: 958}, {x: 1869, y: 938}],
          millisecond: 1589617045000,
          type: 'out'
        },
        {
          station_id: 34,
          station_name: '基站34',
          deck_id: 1,
          passage_id: 2,
          station_points: [{x: 1947, y: 484}, {x: 1952, y: 545}],
          millisecond: 1589617047000,
          type: 'in'
        },
        {
          station_id: 34,
          station_name: '基站34',
          deck_id: 1,
          passage_id: 2,
          station_points: [{x: 1947, y: 484}, {x: 1952, y: 545}],
          millisecond: 1589617052000,
          type: 'out'
        },
        {
          station_id: 22,
          station_name: '基站22',
          deck_id: 1,
          passage_id: 2,
          station_points: [{x: 2454, y: 362}, {x: 2332, y: 509}, {x: 2342, y: 554}],
          millisecond: 1589617057000,
          type: 'in'
        },
        {
          station_id: 22,
          station_name: '基站22',
          deck_id: 1,
          passage_id: 2,
          station_points: [{x: 2454, y: 362}, {x: 2332, y: 509}, {x: 2342, y: 554}],
          millisecond: 1589617062000,
          type: 'out'
        },
        {
          station_id: 25,
          station_name: '基站25',
          deck_id: 1,
          passage_id: 2,
          station_points: [{x: 2677, y: 402}, {x: 2640, y: 520}, {x: 2639, y: 562}],
          millisecond: 1589617067000,
          type: 'in'
        },
        {
          station_id: 25,
          station_name: '基站25',
          deck_id: 1,
          passage_id: 2,
          station_points: [{x: 2677, y: 402}, {x: 2640, y: 520}, {x: 2639, y: 562}],
          millisecond: 1589617072000,
          type: 'out'
        },
      ]
    },
    {
      user: {id: 3, name: '张三丰'},
      paths: [
        {
          station_id: 4,
          station_name: '基站4',
          deck_id: 2,
          passage_id: 4,
          station_points: [{x: 3971, y: 583}],
          millisecond: 1589617024000,
          type: 'in'
        },
        {
          station_id: 4,
          station_name: '基站4',
          deck_id: 2,
          passage_id: 4,
          station_points: [{x: 3971, y: 583}],
          millisecond: 1589617027000,
          type: 'out'
        },
        {
          station_id: 19,
          station_name: '基站19',
          deck_id: 2,
          passage_id: 5,
          station_points: [{x: 4199, y: 347}, {x: 4087, y: 462}, {x: 4068, y: 583}],
          millisecond: 1589617037000,
          type: 'in'
        },
        {
          station_id: 19,
          station_name: '基站19',
          deck_id: 2,
          passage_id: 5,
          station_points: [{x: 4199, y: 347}, {x: 4087, y: 462}, {x: 4068, y: 583}],
          millisecond: 1589617041000,
          type: 'out'
        },
        {
          station_id: 28,
          station_name: '基站28',
          deck_id: 2,
          passage_id: 5,
          station_points: [{x: 4760, y: 592}],
          millisecond: 1589617048000,
          type: 'in'
        },
        {
          station_id: 28,
          station_name: '基站28',
          deck_id: 2,
          passage_id: 5,
          station_points: [{x: 4760, y: 592}],
          millisecond: 1589617055000,
          type: 'out'
        },
        {
          station_id: 26,
          station_name: '基站26',
          deck_id: 1,
          passage_id: 1,
          station_points: [{x: 463, y: 370}],
          millisecond: 1589617060000,
          type: 'in'
        },
        {
          station_id: 26,
          station_name: '基站26',
          deck_id: 1,
          passage_id: 1,
          station_points: [{x: 463, y: 370}],
          millisecond: 1589617067000,
          type: 'out'
        },
        {
          station_id: 34,
          station_name: '基站34',
          deck_id: 1,
          passage_id: 2,
          station_points: [{x: 1947, y: 484}, {x: 1952, y: 545}],
          millisecond: 1589617072000,
          type: 'in'
        },
        {
          station_id: 34,
          station_name: '基站34',
          deck_id: 1,
          passage_id: 2,
          station_points: [{x: 1947, y: 484}, {x: 1952, y: 545}],
          millisecond: 1589617077000,
          type: 'out'
        },
      ]
    }
  ]
};
